import { render, staticRenderFns } from "./AtomImg.vue?vue&type=template&id=7d5072ab"
import script from "./AtomImg.vue?vue&type=script&lang=js"
export * from "./AtomImg.vue?vue&type=script&lang=js"
import style0 from "./AtomImg.vue?vue&type=style&index=0&id=7d5072ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports